import { Outlet } from "react-router-dom";
import EntityDrawer from "./EntityDrawer";

const EntityDrawerWrapper = () => (
  <>
    <Outlet />
    <EntityDrawer />
  </>
);

export default EntityDrawerWrapper;
